import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { NgModule } from '@angular/core';

import { AppRequirementsModule } from 'app/modules/borrower/components/borrower-details/app-requirements/app-requirements.module';
import { BorrowerSidebarComponent } from './borrower-sidebar/borrower-sidebar.component';
import { InfoRequestsModule } from 'app/modules/borrower/components/borrower-details/workflow/workflow-tasks/info-requests.module';
import { NotesModule } from 'app/notes/notes.module';
import { BlastModule } from 'app/blast/blast.module';
import { StipulationsModule } from 'app/modules/borrower/components/borrower-details/workflow/stipulations/stipulations.module';
import { SubmissionSnapshotModule } from 'app/borrower-fd/borrower-fd-sidebar/submission-snapshot/submission-snapshot.module';
import { CollapsibleContainerModule } from 'app/borrower-fd/borrower-fd-sidebar/collapsible-container/collapsible-container.module';
import { ApplicationReviewModule } from 'app/borrower-fd/borrower-fd-sidebar/application-review/application-review.module';
import { PotentialDealsSidebarModule } from 'app/borrower-fd/borrower-fd-sidebar/potential-deals-sidebar/potential-deals-sidebar.module';
import { MatDividerModule } from '@angular/material/divider';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatIconModule } from '@angular/material/icon';

@NgModule( {
  declarations: [
    BorrowerSidebarComponent,
  ],
  exports: [
    BorrowerSidebarComponent,
  ],
  imports: [
    AppRequirementsModule,
    ApplicationReviewModule,
    BlastModule,
    CollapsibleContainerModule,
    CommonModule,
    DragDropModule,
    InfoRequestsModule,
    MatButtonModule,
    MatCardModule,
    MatDividerModule,
    MatIconModule,
    NotesModule,
    PotentialDealsSidebarModule,
    StipulationsModule,
    SubmissionSnapshotModule,
  ],
} )
export class BorrowerSidebarModule {
}
